module.exports = __webpack_public_path__ + "img/cover4.ab373fdf.webp";